<template>
  <div class="overlay-div">
    <div class="position-center">
      <div class="img-div">
        <img class="image" src="../assets/logo.png">
      </div>
      <div class="icon"><i class="far fa-2x fa-spin fa-spinner-third" :style="{'--fa-animation-duration': '400ms'}"></i></div>
      <div class="title">{{(title?title:'لطفا منتظر بمانید...')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props:['title'],
  mounted()
  {
    document.body.classList.add('uk-overflow-hidden')
  }
  ,unmounted()
  {
    document.body.classList.remove('uk-overflow-hidden')
  }
}
</script>


<style scoped>
.bg-light
{
  overflow: hidden;
}
.overlay-div {
  display: flex;
  flex-direction: column;
  position: fixed;
  z-index: 100;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background: #000000a6;
}
.icon {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  color: white;
}
.image
{
  height: 50px;
  margin-bottom: 10px;
  object-fit: contain;
}
.position-center {
  text-align: center;
  margin:auto;
}
.title {
  font-size: 18px;
  color: white;
}
</style>